import { memo } from "react"
import { Typography } from "@mui/material"


const fullScreenCardTitle = ({ title }) => {

  return <Typography mt={5} fontWeight={600} variant='h4' color='text.secondary' gutterBottom align='center'>{title}</Typography>
}

export default memo(fullScreenCardTitle)